import { HiDocumentText, HiLocationMarker } from 'react-icons/hi';
import { services } from './services';
import { aed, E_INVOICING } from './pricing';

/**
 * Specialist solution pages - narrower offers built on the core services that
 * have no card of their own in the navbar's Services dropdown.
 *
 * One list feeds both the navbar's Solutions dropdown and the homepage
 * Solutions section, so a new page (an ERP integration or ZATCA page, say) is
 * added here once and appears in both. Its route still needs adding to
 * src/index.js and route-config.js like any other page.
 *
 * `points` restate what each page already promises - don't add a claim here
 * the page doesn't make. E-invoicing reuses its blog-banner points for that
 * reason.
 */
export const solutions = [
  {
    name: 'UAE E-Invoicing Integration',
    path: '/services/uae-e-invoicing-integration',
    icon: HiDocumentText,
    tag: 'Mandatory from 2027',
    desc: `PINT AE integration · assessment ${aed(E_INVOICING.assessment)}`,
    summary:
      'We connect your ERP, accounting platform or bespoke system to your Accredited Service Provider, and validate PINT AE invoice data before it is submitted.',
    points: services['uae-e-invoicing-integration'].banner.points,
  },
  {
    name: 'Software Development in Dubai',
    path: '/software-development-dubai',
    icon: HiLocationMarker,
    tag: 'For UAE businesses',
    desc: 'Arabic, VAT, local payments and WhatsApp',
    summary:
      'Custom software, mobile apps and AI automation built in Dubai for how UAE businesses actually work.',
    points: ['Arabic and English, built properly', 'UAE payment rails, VAT and WhatsApp', 'Gulf working hours, a team you can meet'],
  },
];
